<button type="button" [disabled]="isDisabled"
        class="btn btn-outline-dark btn-sm" (click)="onAddClicked()">
  <i class="fas fa-plus-circle"></i>
  {{ 'campaign.ad.add' | translate }}
</button>
